import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "container list"
};
const _hoisted_2 = {
  class: "handle-box"
};
const _hoisted_3 = {
  class: "dialog-footer"
};
import { onMounted, reactive, ref } from "vue";
import { httpGet, httpPost } from "@/utils/http";
import { ElMessage, ElMessageBox } from "element-plus";
import { dateFormat, removeArrayItem } from "@/utils/libs";
import { Plus } from "@element-plus/icons-vue";

// 变量定义

export default {
  __name: 'Manager',
  setup(__props) {
    const items = ref([]);
    const item = ref({});
    const showDialog = ref(false);
    const title = ref("");
    const loading = ref(true);
    const formRef = ref(null);
    const rules = reactive({
      username: [{
        required: true,
        message: '请输入用户名',
        trigger: 'change'
      }],
      password: [{
        required: true,
        message: '请输入密码',
        trigger: 'change'
      }],
      repass: [{
        required: true,
        message: '请再次输入密码',
        trigger: 'change'
      }]
    });

    // 获取数据
    const fetchData = () => {
      httpGet('/api/admin/list').then(res => {
        items.value = res.data;
        loading.value = false;
      }).catch(() => {
        ElMessage.error("获取数据失败");
      });
    };
    onMounted(() => {
      fetchData();
    });
    const add = function () {
      showDialog.value = true;
      item.value = {};
    };

    // 重置密码
    const resetPass = function (row) {
      ElMessageBox.prompt('请输入新密码', '重置密码', {
        confirmButtonText: '确认',
        cancelButtonText: '取消'
      }).then(({
        value
      }) => {
        httpPost("/admin/resetPass", {
          id: row.id,
          password: value
        }).then(() => {
          ElMessage.success("操作成功");
        }).catch(e => {
          ElMessage.error("操作失败：" + e.message);
        });
      }).catch(() => {});
    };
    const save = function () {
      formRef.value.validate(valid => {
        if (item.value.password !== item.value.repass) {
          return ElMessage.error("两次输入密码不一致！");
        }
        if (valid) {
          showDialog.value = false;
          httpPost('/api/admin/save', item.value).then(res => {
            ElMessage.success('操作成功！');
            fetchData();
          }).catch(e => {
            ElMessage.error('操作失败，' + e.message);
          });
        } else {
          return false;
        }
      });
    };
    const enable = row => {
      httpPost('/api/admin/enable', {
        id: row.id,
        enabled: row.status
      }).then(() => {
        ElMessage.success("操作成功！");
      }).catch(e => {
        ElMessage.error("操作失败：" + e.message);
      });
    };
    const remove = function (row) {
      httpGet('/api/admin/remove?id=' + row.id).then(() => {
        ElMessage.success("删除成功！");
        items.value = removeArrayItem(items.value, row, (v1, v2) => {
          return v1.id === v2.id;
        });
      }).catch(e => {
        ElMessage.error("删除失败：" + e.message);
      });
    };
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_switch = _resolveComponent("el-switch");
      const _component_el_popconfirm = _resolveComponent("el-popconfirm");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _directive_loading = _resolveDirective("loading");
      return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
        type: "primary",
        icon: _unref(Plus),
        onClick: add
      }, {
        default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode("新增")])),
        _: 1
      }, 8, ["icon"])]), _createVNode(_component_el_row, null, {
        default: _withCtx(() => [_createVNode(_component_el_table, {
          data: items.value,
          "row-key": row => row.id,
          "table-layout": "auto"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            prop: "username",
            label: "用户名"
          }), _createVNode(_component_el_table_column, {
            prop: "last_login_ip",
            label: "最后登录IP"
          }), _createVNode(_component_el_table_column, {
            label: "最后登录时间"
          }, {
            default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(_unref(dateFormat)(scope.row['last_login_at'])), 1)]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            prop: "enabled",
            label: "启用状态"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_switch, {
              modelValue: scope.row['status'],
              "onUpdate:modelValue": $event => scope.row['status'] = $event,
              onChange: $event => enable(scope.row)
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "创建时间"
          }, {
            default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(_unref(dateFormat)(scope.row['created_at'])), 1)]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "操作",
            width: "180"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_button, {
              size: "small",
              type: "primary",
              onClick: $event => resetPass(scope.row)
            }, {
              default: _withCtx(() => _cache[6] || (_cache[6] = [_createTextVNode("重置密码")])),
              _: 2
            }, 1032, ["onClick"]), _createVNode(_component_el_popconfirm, {
              title: "确定要删除当前记录吗?",
              onConfirm: $event => remove(scope.row),
              width: 200
            }, {
              reference: _withCtx(() => [_createVNode(_component_el_button, {
                size: "small",
                type: "danger"
              }, {
                default: _withCtx(() => _cache[7] || (_cache[7] = [_createTextVNode("删除")])),
                _: 1
              })]),
              _: 2
            }, 1032, ["onConfirm"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["data", "row-key"])]),
        _: 1
      }), _createVNode(_component_el_dialog, {
        modelValue: showDialog.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => showDialog.value = $event),
        title: "添加用户",
        "close-on-click-modal": false
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_3, [_createVNode(_component_el_button, {
          onClick: _cache[3] || (_cache[3] = $event => showDialog.value = false)
        }, {
          default: _withCtx(() => _cache[8] || (_cache[8] = [_createTextVNode("取消")])),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: save
        }, {
          default: _withCtx(() => _cache[9] || (_cache[9] = [_createTextVNode("提交")])),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          model: item.value,
          "label-width": "120px",
          ref_key: "formRef",
          ref: formRef,
          rules: rules
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "用户名：",
            prop: "username"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: item.value.username,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => item.value.username = $event),
              autocomplete: "off"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "密码：",
            prop: "password"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: item.value.password,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => item.value.password = $event),
              type: "password",
              autocomplete: "off"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "重复密码：",
            prop: "repass"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: item.value.repass,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => item.value.repass = $event),
              type: "password",
              autocomplete: "off"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])]),
        _: 1
      }, 8, ["modelValue"])])), [[_directive_loading, loading.value]]);
    };
  }
};